var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 64,
    viewBox: "0 0 36 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0897 41.0101C36.1997 44.2101 36.4597 47.9201 34.9897 51.3801C32.5597 56.8801 25.7097 61.4901 18.0997 62.7101C17.2697 62.8401 7.5997 63.6701 4.4697 63.3501L0.179688 63.4801V0.63008H4.14969C6.76969 0.25008 17.2097 1.14008 18.1597 1.27008C25.7797 2.61008 32.6197 7.16008 34.9897 12.6601C36.5297 16.1201 36.2097 19.8301 34.0897 23.0301C31.0797 27.7701 23.8497 30.9701 16.4897 32.1201C21.4797 32.8201 30.4997 35.3801 34.0897 41.0201V41.0101ZM3.55969 4.02008V30.3201C18.7297 29.0401 28.1997 25.9701 31.2697 21.2301C32.7397 18.8601 32.9997 16.5601 31.9097 14.0001C29.9297 9.58008 24.0997 5.81008 17.5797 4.66008C16.9397 4.53008 6.75969 3.70008 4.39969 4.02008H3.5697H3.55969ZM31.2697 42.8001C26.7297 35.9501 9.57969 34.4201 3.55969 33.8401V60.0101L4.51968 59.9501H4.57968C7.45968 60.2101 16.7997 59.4401 17.5097 59.3101C24.0397 58.2201 29.9297 54.3801 31.8397 49.9701C32.9897 47.4701 32.7397 45.1701 31.2597 42.8001H31.2697Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperB);
export default __webpack_public_path__ + "static/media/UPPER_B.6068a2f2d28f4dafafed8d07b7c0bdcf.svg";
export { ForwardRef as ReactComponent };